<template>
  <div class="toolbar" :class="{'toolbar-active' : scrollPosition > 0}">
    <div class="container-fluid">
      <div class="row pt-3">
        <div class="col-md-12 align-middle">
          <div class="form-group clearfix justify-content-between">
            <div class="dropdown float-right">
              <button class="btn btn-secondary btn-more-radius dropdown-toggle align-middle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="text-white">{{getPersonelName}}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <router-link class="dropdown-item" to="/logout">Oturumu Kapat</router-link>
              </div>
            </div>
            <div v-if="1==0" class="dropdown float-right mr-2">
              <button class="btn btn-secondary rounded-circle align-middle" type="button" 
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-bell text-white mr-2"></i><span class="badge badge-danger">24</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <router-link class="dropdown-item" to="/logout">Oturumu Kapat</router-link>
              </div>
            </div>
            <input v-if="1==0" type="text" class="global-search form-control btn-more-radius float-right mr-2" 
              placeholder="İhtiyacınız olan şeyi arayın..." />
            <CurrencyParity class="float-right mr-2" />
            <div class="form-control global-title text-truncate">{{title}} <span class="text-muted">{{titleEng}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CurrencyParity from '../tool/CurrencyParity'

export default {
  name: 'ToolBar',
  components: {
    'CurrencyParity': CurrencyParity,
  },
  computed : {
  },
  data () {
    return {
      scrollPosition: null
    }
  },
  props: {
    title : String,
    titleEng : String
  },
  computed: {
    getPersonelName : function() { return this.$store.state.user.personelName },
    getSessionId : function() { return this.$store.getters.getSessionId },
    getPageTitle : function() { return this.$store.getters.getPageTitle },
    notificationCount: function() { return 0; },
    getPageTitle2 : function() { return "" }
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
  },
  created() { },
  mounted() {
    window.addEventListener('scroll', this.updateScroll)
  },
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },
}
</script>

<style scoped>
  .toolbar {
    position: fixed;
    z-index: 2;
    top: 0;
    right: 0;
    width: calc(100vw - 60px);
    height: 80px;
    background-color: rgba(0,0,0,0);
    transition: background-color .15s;
    border-bottom: 1px solid #F7F7F7;
  }

  .toolbar-active {
    background-color: #F7F7F7;
    transition: background-color .15s;
    border-bottom: 1px solid #D0D0D0;
    -webkit-box-shadow: 0px 20px 40px -20px rgba(0,0,0,0.33);
    -moz-box-shadow: 0px 20px 40px -20px rgba(0,0,0,0.33);
    box-shadow: 0px 20px 40px -20px rgba(0,0,0,0.33);
  }

  .global-search {
    width: 44%;
  }

  .global-title {
    font-size: 1.2rem;
    width: auto;
    background: none;
    border: none;
    font-weight: 500;
    color: #000000;
  }

  .profile-pic {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 10px;
  }

</style>


// WEBPACK FOOTER //
// src/components/ToolBar.vue